<template>
	<main id="subPage" class="admin">
		<!-- 카테고리 -->
        <section id="category">
			<h2>관리자 메뉴</h2>
			<ul class="breadCrumb">
				<li class="home"></li>
				<li class="web">
					<p class="pageTxt">관리자 메뉴</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
						<li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
					</ul> 
				</li>
                <li class="web">
					<p class="pageTxt">할인차량관리</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
						<li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
						<li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
                        <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
						<li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
					</ul> 
				</li>
                <li>
					<p class="pageTxt">할인차량 관리</p>
					<ul class="depth">
						<li><router-link to="/discountvehicle" title="할인차량 관리">할인차량 관리</router-link></li>
						<li><router-link to="/freevehicle" title="무료차량 관리">무료차량 관리</router-link></li>
					</ul> 
				</li>
			</ul>
        </section>

		<!-- 컨텐츠 영역 -->
		<section id="content">
			<div class="inner">
				<h3 class="pageTitle">할인차량 조회</h3>
                <article>
                    <!--table-->
                    <div class="table horizontal-table">
                        <table>
                            <caption>할인차량 조회 테이블</caption>
                            <colgroup>
                                <col style="width:15%; min-width: 80px;"/>
                                <col style="width:35%"/>
                                <col style="width:15%; min-width: 80px;"/>
                                <col style="width:auto"/>
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th scope="row">사용자명</th>
                                    <td colspan="3">{{ discountCar.carOwnerNm }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">차량번호</th>
                                    <td colspan="3">{{ discountCar.carNo }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">할인유형</th>
                                    <td>{{ discountCar.discountNm }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">할인기간</th>
                                    <td colspan="3">{{ discountCar.startDt }} ~ {{ discountCar.endDt }}</td>
                                </tr>
                                <tr>
                                    <th scope="row">비고</th>
                                    <td colspan="3">{{  discountCar.note }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--//table-->

                </article>
                <article class="btnArea">
                    <button type="button" class="btn border" @click="$router.push('discountvehicle')">목록</button>
                    <button type="button" class="btn gray" @click="deleteConfirm()">삭제</button>
                    <button type="button" class="btn blue" @click="update()">수정</button>
                </article>
            </div>
        </section>
	</main>
</template>

<script>
import axios from "../../../util/axios";

export default {
	data(){
        return {
            carId: "",
            discountCar: {},
		}
	},
	
	mounted(){
        const carId = this.$route.query.seqId;
        if(!carId) {
			alert("잘못된 접근입니다.");
			this.$router.push('/businessmembership');
        }
        this.carId = carId;
        this.findDiscountCar();
	},

    methods: {
        async findDiscountCar() {
            const res = await axios('get', "/api/admin/discount/view.json", {
                seqId: this.carId
            });
            this.discountCar = res.data.resultVo.result;
        },

        update() {
            this.$router.push({
				name : 'discountvehicleupdate',
				params : {data : this.discountCar}
			})
        },

        deleteConfirm(){
			this.$confirm(
				{
					message: `삭제하시겠습니까?`,
					button: {
						no: '아니오',
						yes: '예'
					},
					 callback: confirm => {
						if (confirm) {
						this.deleteBtn();
						}
					}
				}
			)
		},

    async deleteBtn(){
		let apiParams = new FormData();
        apiParams.append("seqId", this.carId);
        await axios('post', "/api/admin/discount/delete.json", apiParams);
        await this.$router.push('discountvehicle');
		},
	},
}
</script>

